import { IconButton } from "@mui/material";
import { useForm } from "react-hook-form";
import ReactSelect from "react-select";
import styled from "styled-components";
import { TrashIcon } from "../../../assets/icons";
import { formatDate } from "../../../helpers/date";
import { InputAmmount } from "./InputAmmount";

const CardMovimientos = ({
  id,
  type,
  date,
  amount,
  divisa,
  status,
  showModal,
  setShowModal,
  onClick, 
  registro,
  onChangeInput,
  onDelete,
}) => {
  const {
    register,
    // handleSubmit,
    control,
    formState: { errors },
  } = useForm({});
  const parseAmount = (amount) => {
    let amountReplaced = amount.replace(/,/g, "");
    return amountReplaced.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  const options = [
    { value: "mxn", label: "MXN" },
    { value: "usd", label: "USD" },
  ];
  return (
    <Container onClick={onClick}>
      <Property style={{ width: "55px" }}>{id}</Property>
      <Property style={{ width: "216px" }}>{type}</Property>
      <Property style={{ width: "86px" }}>{formatDate(date)}</Property>
      <Property style={{ width: "120px" }}>
        {!registro && type !== "Indemnización"? <InputAmmount
          name="monto"
          type="number"
          control={control}
          placeholder={amount}
          forceValue={amount}
          onChangeHandler={onChangeInput}
          register={{ ...register("montoMovimiento") }}
          errorMessage={errors.montoMovimiento?.type}
          ref={register}
        /> : parseAmount(amount)}
      </Property>
      <Property style={{ width: "130px", height: "32px" }}>
        {type === "Recuperaciones" && !registro ? (
          <div style={{ width: "100%" }}>
            <ReactSelect
              onChange={(e) => onChangeInput({target: {value: e.value, name: "moneda"}})}
              options={options}
              placeholder="USD / MXN"
              defaultValue={options[0]}
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  borderRadius: "8px",
                  height: "32px"
                }),
              }}
            />
          </div>
        ) : (
          divisa
        )}
      </Property>
      {status === "registrar" ? (
        <StyledButton estatus={status} onClick={() => setShowModal(true)}>
          Registrar Pago
        </StyledButton>
      ) : 
      status === "parcial" ? (
        <StyledButton estatus={status} onClick={() => setShowModal(true)}>
          Editar Pago
        </StyledButton>
      ) :
      status === "pagado"  ? (
        <StyledButton estatus={status} onClick={() => setShowModal(true)}>
          Visualizar pago
        </StyledButton>
      ):
     (
        <div style={{ width: "200px", margin: "0 24px" }} ></div>
      )}
       <IconButton onClick={!registro && onDelete}>
        {!registro ?  <TrashIcon/> : <div style={{ width: "24px", margin: "0px" }} ></div>}
      </IconButton>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  gap: 38px;
  justify-content: space-between;
  align-items: center;
  margin-bottom:55px;
`;

const Property = styled.div`
  /* padding: 8px 0px; */
  border-radius: 8px;
  display: grid;
  place-items: center;
  font-size: 14px;
  height: 32px;
`;

const StyledButton = styled.button`
  cursor: pointer;
  font-weight: 700;
  border-radius: 20px;
  width: 200px;
  height: 42px;
  display: grid;
  place-content: center;
  font-size: 14px;
  transition: 300ms;
  margin: 0 24px;
  &:hover {
    opacity: 0.8;
  }
  background-color: ${({ estatus }) =>
    estatus === "pagado" ? "var(--secondary-forest-green)" : "#fff"};
  color: ${({ estatus }) => {
    if (estatus === "registrar") {
      return "var(--secondary-forest-green)";
    } else if (estatus === "parcial") {
      return "var(--primary-pistachio)";
    }
    return "#fff";
  }};
  border: 2px solid
    ${({ estatus }) => {
      if (estatus === "registrar" || estatus === "pagado")  {
        return "var(--secondary-forest-green)";
      } else if (estatus === "parcial") {
        return "var(--primary-pistachio)";
      }
      return "#fff";
    }};
  opacity: ${({ estatus }) => {
    if (estatus === "registrar" || estatus === "parcial" || estatus === "pagado") {
      return "1";
    } 
    return "0";
  }};
`;

export default CardMovimientos;
